export default __webpack_public_path__ + "aac350099ba4113112d2746d8e343e4f.svg";